import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

export interface SelectedTenant {
  id: string;
  name: string;
}

interface TenantStore {
  selectedTenant: SelectedTenant | null;
  setSelectedTenant: (tenant: SelectedTenant | null) => void;
}

export const useTenantStore = create<TenantStore>()(
  persist(
    (set) => ({
      selectedTenant: null,
      setSelectedTenant: (tenant) => set({ selectedTenant: tenant }),
    }),
    {
      name: 'xtnd-admin-selected-tenant',
      storage: createJSONStorage(() => localStorage),
    }
  )
);

export const useSelectedTenant = () => {
  const { selectedTenant, setSelectedTenant } = useTenantStore();
  return { selectedTenant, setSelectedTenant };
};
